export type SquareContact = {
  givenName: string;
  familyName?: string;
  email?: string;
  country?: string; // A 2-letter string containing the ISO 3166-1 country code of the contact address.
  countryName?: string;
  region?: string;
  city?: string;
  postalCode?: string;
  phone?: string;
  addressLines?: string[];
};

export type SquareBuyerVerificationDetails = {
  amount: string;
  currencyCode: string;
  billingContact: SquareContact;
};

export enum SquareVerifyBuyerMessageType {
  // Widget -> Frame
  VerifyBuyer = 'verify-buyer',

  // Frame -> Widget
  Ready = 'frame-ready',
  BuyerVerificationDisplayed = 'buyer-verification-displayed',
  BuyerVerified = 'buyer-verified',
  BuyerVerificationFailed = 'buyer-verification-failed',
}

export type SquareVerifyBuyerMessage = {
  appId: string;
  locationId: string;
  nonce: string;
  verificationDetails: SquareBuyerVerificationDetails;
};

export type SquareMessageFromFrame =
  | {
      type: SquareVerifyBuyerMessageType.Ready;
    }
  | {
      type: SquareVerifyBuyerMessageType.BuyerVerificationDisplayed;
    }
  | {
      type: SquareVerifyBuyerMessageType.BuyerVerified;
      payload?: string;
    }
  | {
      type: SquareVerifyBuyerMessageType.BuyerVerificationFailed;
      error?: Error;
    };

export type SquareMessageToFrame = {
  type: SquareVerifyBuyerMessageType.VerifyBuyer;
  payload: SquareVerifyBuyerMessage;
};

export type SquareVerifyBuyerFn = (
  source: string, // card nonce
  verificationDetails: {
    intent: 'CHARGE' | 'STORE';
    amount: string;
    currencyCode: string; // This must be an ISO 4217 currency code and used in the merchant location.
    billingContact: SquareContact;
  },
  callback: (
    err: {
      type:
        | 'UNKNOWN_API_ERROR'
        | 'VERIFICATION_NOT_SUCCESSFUL'
        | 'VERIFICATION_IN_PROGRESS'
        | 'VERIFICATION_TIMEOUT'
        | 'INVALID_REQUEST_ERROR';
      message: string; // The details of the verification error
    },
    result: {
      token: string;
      userChallenged: boolean;
    }
  ) => void,
  params?: {
    elementSelector: string;
    challengeDisplayedCallback(): void;
    challengeHiddenCallback(): void;
  }
) => void;
